import { EventEmitter, Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import * as signalR from "@microsoft/signalr";
import { HubConnection } from '@microsoft/signalr';
import { SignalRConnectionInfo } from "../models/signalR/signalRConnectionInfo";
import { environment } from "src/environments/environment";
import { Helpers } from "../helpers/helpers";
import { SecurityService } from "src/app/services/security.service";
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class SignalRService {
  private readonly _httpClient: HttpClient;
  private readonly _baseUrl: string;
  private hubConnection!: HubConnection;

  signalUserNotificationReceived = new EventEmitter<any>();
  showNotificationMenuEvent = new EventEmitter<boolean>();
  signalCustomNotificationReceived = new EventEmitter<any>();

  constructor(http: HttpClient, private securityService: SecurityService) {
    this._httpClient = http;
    this._baseUrl = environment.usernotificationService.url + environment.usernotificationService.auth;
  }

  private getConnectionInfo(): Promise<SignalRConnectionInfo> {

    return new Promise<any>((resolve, reject) => {
      let currentUser = this.securityService.currentUserValue;
      if (currentUser != null) {
        const medPointPlatformId = Helpers.getPlatformId();
        let requestUrl = `${this._baseUrl}`;
        const headers = new HttpHeaders({ 'x-ms-client-profileid': currentUser.UserGuid + '_' + medPointPlatformId, 'Authorization': `Bearer ${currentUser.Token}` });
        lastValueFrom(this._httpClient.post<SignalRConnectionInfo>(requestUrl, "", { headers: headers }))
          .then(
            (response?: any) => {
              resolve(response);
            },
            (err) => {
              reject(err);
            });
      } else {
        reject("User not logged in.");
      }
    });


  }

  init() {
    try {

      this.getConnectionInfo().then((info) => {
        let options: signalR.IHttpConnectionOptions = {
          accessTokenFactory: () => info.accessToken,
          transport: signalR.HttpTransportType.LongPolling
        };

        this.hubConnection = new signalR.HubConnectionBuilder()
          .withUrl(info.url, options)
          .configureLogging(signalR.LogLevel.Information)
          .build();

        this.hubConnection.start().then(() => {
          this.registerSignalEvents();
        }).catch((err) => {
          console.error(err.toString());
        });

        this.retryCount = 0;

      }).catch((err) => {
        console.log('SignalR Init error: ', err);
        this.retryInitConnection();
      }).finally(() => {

      });

    } catch (e) {
      console.log('SignalR Init error: ', e);
      this.retryInitConnection();
    }
  }

  private retryCount: number = 0;
  private readonly maxCount: number = 6;
  private readonly retryInterval: number = 10 * 1000; // retry after 20 Second

  private retryInitConnection() {
    if (this.retryCount < this.maxCount) {
      setTimeout(() => {
        this.init();
        this.retryCount = this.retryCount + 1;
      }, this.retryInterval);
    }
  }

  private registerSignalEvents() {
    this.hubConnection.on("TriPortUserNotifications", (data: any) => {
      this.signalUserNotificationReceived.emit(data);
    });
    this.hubConnection.on("CustomPostMessage", (data: any) => {
      this.signalCustomNotificationReceived.emit(data);
    });
  }

  pushServiceResponseToNotification(data:any) {
    this.signalUserNotificationReceived.emit(data);
  }
}
